//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { getSelectedReelIds } from '@uia/approve-for-galleries/getSelectedReelIds';

export const getIsItemInAllReels = createSelector(
  getSelectedReelIds,
  (state: ICuralateStore) => state.uiaModal.approveForGalleries.approvedReels,
  (state: ICuralateStore) =>
    state.uiaModal.approveForGalleries.isBazaarvoiceSyndicationSelected,
  (selectedReelIds, approvedReelIds, isBvSelected) => {
    //If client is only syndicating always allow to approve to syndication
    if (selectedReelIds.length == 0 && isBvSelected) {
      return false;
    }

    for (const reelId of selectedReelIds) {
      if (!approvedReelIds.includes(reelId)) {
        return false;
      }
    }

    return true;
  },
);
